var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from 'react';
var SvgComponent = function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 35,
    viewBox: "0 0 23 35",
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8008 34.501C22.8008 34.501 22.8007 -2.45044 22.8008 0.46431C22.8009 3.37906 22.8009 6.29381 18.5258 10.6659C15.854 13.3984 9.28614 20.1154 4.73554 24.7693C2.97114 26.5737 4.24961 29.6118 6.77333 29.6118L11.4006 29.6118C11.4006 29.6118 16.3882 29.6118 19.9507 29.6118C22.8009 29.6118 22.8008 34.501 22.8008 34.501Z",
    fill: "#4A336C"
  })));
};
export default __webpack_public_path__ + "static/media/tiltedBeak.83af27b3.svg";
export { SvgComponent as ReactComponent };